import { render, staticRenderFns } from "./CriteriaCreate.vue?vue&type=template&id=4264e909"
import script from "./CriteriaCreate.vue?vue&type=script&lang=js"
export * from "./CriteriaCreate.vue?vue&type=script&lang=js"
import style0 from "./CriteriaCreate.vue?vue&type=style&index=0&id=4264e909&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports